import { Suspense } from "react";

const WithSuspense = (Component) => {
  const WithSuspenseWrapper = (props) => (
    <Suspense fallback={<div>Loading...</div>}>
      <Component {...props} />
    </Suspense>
  );

  WithSuspenseWrapper.displayName = `WithSuspense(${
    Component.displayName || Component.name || "Component"
  })`;

  return WithSuspenseWrapper;
};

export default WithSuspense;
